import { TContentMetadata } from "@telia-company/tv.web-player-shared";

export const getUnhandledMetadata = (): Promise<TContentMetadata> =>
  new Promise((resolve /* reject */) => {
    resolve({
      title: "",
    });
  });
